import { LoadingContainer } from 'components/loadingContainer'
import { useImagesByIds } from 'hooks/user/useImage/useImageById'
import { ShowWithImages } from 'types/Show'

import {
    Container,
    ContentWrapper,
    Contributor,
    ContributorResponsible,
    ContributorRole,
    ContributorsContainer,
    ContributorText,
    DataWrapper,
    Description,
    DescriptionText,
    Image,
    ImageContainer,
    ImageGallery,
    ImageGalleryContainer,
} from './details.style'

interface Props {
    data: ShowWithImages
    eventDescription?: string
}

export const Details = ({ data, eventDescription }: Props) => {
    const imageIds = data.images.filter((image) => !image.is_cover).map((image) => image.image_id.toString())

    const { images, isLoading, error } = useImagesByIds(imageIds)

    /**
     * A probléma hogy nem lehet jelenleg eldönteni melyik esemény leírását kellene megjeleníteni.
     * Jelenleg az első esemény leírását jelenítjük meg, de ez nem feltétlenül a legmegfelelőbb megoldás.
     * A jövőben érdemes lenne egyértelműsíteni, hogy melyik esemény leírása jelenjen meg a műsor részleteinél.
     * {eventDescription && <DescriptionText>{eventDescription}</DescriptionText>}
     */

    return (
        <Container>
            <ContentWrapper>
                <DataWrapper>
                    <Description>
                        <DescriptionText>{data.description}</DescriptionText>
                    </Description>
                    <ContributorsContainer>
                        <ContributorText>Közreműködők</ContributorText>
                        {data.contributors.map((contributor, index) => (
                            <Contributor key={index}>
                                <ContributorRole>{contributor.role}</ContributorRole>
                                <ContributorResponsible>{contributor.responsible}</ContributorResponsible>
                            </Contributor>
                        ))}
                    </ContributorsContainer>
                </DataWrapper>
                <ImageGalleryContainer>
                    <LoadingContainer isLoading={isLoading} error={error}>
                        <ImageGallery>
                            {images?.map((image, index) => (
                                <ImageContainer key={image.image_id}>
                                    <Image src={image.image_url}></Image>
                                </ImageContainer>
                            ))}
                        </ImageGallery>
                    </LoadingContainer>
                </ImageGalleryContainer>
            </ContentWrapper>
        </Container>
    )
}
